import styled from 'styled-components';

import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';

export const AddANewAddressContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

export const AddIcon = styled(props => <CapsuleIcon {...props} />)`
  margin-top: 2px;
  margin-right: 5px;
`;
